'use client'

import { QUERY_ROUTES } from '@/core/constants/routes'
import { useDeleteSearchParam } from '@/core/hooks/use-delete-search-params'
import { updateHistoryState } from '@/core/lib/utils/routing'
import { useAuth } from '@/core/store/auth'
import { usePathname } from 'next/navigation'
import { useCallback, useEffect } from 'react'
import { Modal, ModalBody } from '../../../../core/ui/atoms/modal'
import { SendVerificationCode } from './send-verification-code'

export const CustomerLoginModal = () => {
  const { isAuthenticated } = useAuth()
  const pathname = usePathname()
  const { searchParams, deleteSearchParam } = useDeleteSearchParam()

  const handleSuccess = useCallback(() => {
    const url = new URL(pathname, window.location.origin)
    const verifyPhone = QUERY_ROUTES.verifyPhone

    url.searchParams.set(verifyPhone.name, verifyPhone.value)

    updateHistoryState(url.toString())
  }, [pathname])

  const handleClose = useCallback(() => {
    deleteSearchParam(QUERY_ROUTES.sendVerificationCode.name, {
      clientOnly: true,
    })
  }, [deleteSearchParam])

  useEffect(() => {
    if (isAuthenticated) {
      handleClose()
    }
  }, [isAuthenticated, handleClose])

  return (
    <Modal
      className='w-96'
      isOpen={
        QUERY_ROUTES.sendVerificationCode.value ===
        searchParams.get(QUERY_ROUTES.sendVerificationCode.name)
      }
      onClose={handleClose}
      hideCloseButton
      disableBackdropDismiss
    >
      <ModalBody className='p-6'>
        <SendVerificationCode onSuccess={handleSuccess} onClose={handleClose} />
      </ModalBody>
    </Modal>
  )
}
